import { AuditLog as ApiAuditLog } from '@infuse/api/audit-log';
import { AuditLog } from './model';

export const apiResultToDomain = (apiResult: ApiAuditLog): AuditLog => {
  return {
    id: apiResult.id,
    userId: apiResult.userId,
    objectType: apiResult.objectType,
    objectId: apiResult.objectId,
    action: apiResult.action,
    description: apiResult.description,
    success: apiResult.success,
    ipAddress: apiResult.ipAddress,
    uri: apiResult.uri,
    httpMethod: apiResult.httpMethod,
    correlationId: apiResult.correlationId,
    createdAt: new Date(apiResult.createdAt)
  };
};
